module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4159@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4159%402x.png
// module id = rkF1
// module chunks = 93